import { StrapiCreate, StrapiUpdate } from './../../types/strapi/strapi'
import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, { EndpointQueryParameters, StrapiSingle } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import CalculationPosition from '../../types/api/calculation-position'
import { calculationsApi } from './calculations-api'

export const calculationPositionsApi = createApi({
    reducerPath: 'calculationPositionsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['CalculationPositions'],
    endpoints: builder => ({
        getCalculationPositions: builder.query<
            Strapi<CalculationPosition>,
            EndpointQueryParameters | void
        >({
            query: getQuery('/calculation-positions'),
            providesTags: ['CalculationPositions'],
        }),
        getCalculationPositionByDocId: builder.query<
            StrapiSingle<CalculationPosition>,
            [string, EndpointQueryParameters | void]
        >({
            query: ([docId, params]) => getQuery(`/calculation-positions/${docId}`)(params),
        }),
        createCalculationPosition: builder.mutation<
            StrapiSingle<CalculationPosition>,
            StrapiCreate<CalculationPosition>
        >({
            query: body => ({
                url: '/calculation-positions',
                method: 'POST',
                body,
            }),
            // invalidatesTags: ['CalculationPositions'],
            // async onQueryStarted(_, { dispatch, queryFulfilled }) {
            //     try {
            //         await queryFulfilled
            //         dispatch(calculationsApi.util.invalidateTags(['Calculations']))
            //     } catch (error) {
            //         console.error('Ошибка ревалидации расчетов:', error)
            //     }
            // },
        }),
        updateCalculationPosition: builder.mutation<
            StrapiSingle<CalculationPosition>,
            StrapiUpdate<CalculationPosition>
        >({
            query: ({ docId, body, queryParams }) => ({
                url: getQuery(`/calculation-positions/${docId}`)(queryParams),
                method: 'PUT',
                body,
            }),
        }),
        deleteCalculationPosition: builder.mutation<void, string>({
            query: docId => ({ url: `/calculation-positions/${docId}`, method: 'DELETE' }),
            // invalidatesTags: ['CalculationPositions'],
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(calculationsApi.util.invalidateTags(['Calculations']))
                } catch (error) {
                    console.error('Ошибка ревалидации расчетов:', error)
                }
            },
        }),
        recalcAllFromExcel: builder.mutation<
            { updated: number; errors: number },
            void
        >({
            query: () => ({
                url: '/calculation-positions/recalc-all-from-excel',
                method: 'POST',
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(calculationsApi.util.invalidateTags(['Calculations']))
                } catch (error) {
                    console.error('Ошибка ревалидации после пересчета:', error)
                }
            },
        }),
        verifyCalculations: builder.mutation<
            {
                details: Array<{
                    excelId: string
                    rowNumber: number
                    field: string
                    excelValue: any
                    systemValue: any
                }>
            },
            void
        >({
            query: () => ({
                url: '/calculation-positions/verify-calculations',
                method: 'POST',
            }),
        }),
    }),
})

export const {
    useGetCalculationPositionsQuery,
    useLazyGetCalculationPositionsQuery,
    useLazyGetCalculationPositionByDocIdQuery,
    useCreateCalculationPositionMutation,
    useUpdateCalculationPositionMutation,
    useDeleteCalculationPositionMutation,
    useRecalcAllFromExcelMutation,
    useVerifyCalculationsMutation,
} = calculationPositionsApi
